<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          @keyup.enter="publications(page)"
          filled
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Buscar"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="5">
        <v-autocomplete
          @keyup.enter="publications(page)"
          filled
          v-model="brand_id"
          :items="keys"
          item-text="name"
          :item-value="(item) => item"
          prepend-inner-icon="mdi-magnify"
          label="Marcas"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="12" md="1" class="text-center">
        <v-btn
          :loading="loading"
          @click="publications(page)"
          color="blue darken-3"
          dark
          fab
        >
          <v-icon>mdi-text-box-search-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="12">
        <v-data-iterator
          :items="itemsPublications"
          :items-per-page.sync="itemsPerPage"
          :page="page"
          search
          :sort-desc="sortDesc"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-row v-if="searchProducts">
              <v-col
                v-for="item in props.items"
                :key="item.name"
                cols="12"
                sm="6"
                md="3"
                lg="3"
                class="d-flex stretch"
              >
                <v-card class="shadow-small round" @click="details(item)">
                  <v-card-text>
                    <v-img
                      v-if="item.pictures.length > 0"
                      height="180"
                      :lazy-src="item.pictures[0]"
                      :src="item.pictures[0]"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <div
                      class="mt-3 text-uppercase font-weight-bold"
                      style="font-size: 18px"
                    >
                      {{ item.title }}
                    </div>
                    <v-card-subtitle
                      class="px-0 font-weight-bold pt-1 pb-0 ml-1"
                    >
                      PVP: {{ item.pvp | currency }}
                    </v-card-subtitle>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="mx-auto">
                <looping-rhombuses-spinner
                  class="mx-auto"
                  :animation-duration="2500"
                  :rhombus-size="80"
                  color="#402DCE"
                />
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
        <v-pagination
          v-model="pagination.page"
          :length="pagination.lastPage"
          circle
          @input="publications(pagination.page)"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LoopingRhombusesSpinner } from "epic-spinners";
export default {
  components: {
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      loading: false,
      searchProducts: false,
      search: "",
      sortDesc: false,
      page: 1,
      itemsPerPage: 12,
      sortBy: "",
      items: [],
      keys: [],
      brand_id: ''
    };
  },

  computed: {
    itemsPublications() {
      return this.$store.getters["product/ITEMS_PRODUCTS"];
    },
    itemsDiscount() {
      return this.$store.getters["auth/DISCOUNT_CLIENT"];
    },
    pagination() {
      return this.$store.getters["product/GET_PAGINATION"];
    },
  },

  created() {
    this.publications();
    this.getBrands();
  },

  methods: {
    pvc(item) {
      let pvc_total_product = item - (item * this.itemsDiscount) / 100;

      return pvc_total_product;
    },

    async publications(page = 1) {
      console.log('this.brand_id',this.brand_id)
      try {
        this.searchProducts = false;
        const request = {
          // store: ,
          page: page,
          per_page: 12,
          paginate: true,
          product_id: "",
          search: this.search,
          brand_id: this.brand_id.id
        };

        await this.$store.dispatch("product/INDEX", request);

        this.searchProducts = true;
      } catch (error) {
        this.searchProducts = false;
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.searchProducts = true;
      }
    },

    async getBrands() {
      const response = await this.$store.dispatch("product/BRANDS");
      this.keys = response;
    },

    details(product) {
      this.$store.commit("product/SET_ONE_PRODUCT", product);
      this.$router.push({
        name: "details_products",
        params: { id: product.id },
      });
    },
  },
};
</script>

<style>
.shadow-small {
  box-shadow: 0 2px 4px rgba(27, 31, 35, 0.15) !important;
}

.round {
  border-radius: 20px !important;
}
</style>